<div class="wrap">
    <app-header></app-header>
    <div class="main-holder">
        <app-nav></app-nav>
        <div class="main">
            <div class="main-content">
                <div class="bread">
                    <ol *ngIf="!showDetails">
                        <li><a [routerLink]="['/']"><img src="../../../../assets/okito/images/icons/home.svg"></a></li>
                        <img src="../../../../assets/okito/images/icons/chevron-right.svg">
                        <li><span>Services</span></li>
                    </ol>
                    <ol *ngIf="showDetails">
                        <li><a [routerLink]="['/']"><img src="../../../../assets/okito/images/icons/home.svg"></a></li>
                        <img src="../../../../assets/okito/images/icons/chevron-right.svg">
                        <li><a (click)="returnToList()" style="cursor: pointer;">Services</a></li>
                        <img src="../../../../assets/okito/images/icons/chevron-right.svg">
                        <li><span>{{ serviceLabel(detailViewed!.serviceType) }}</span></li>
                    </ol>
                </div>
                <div class="content-title">
                    <h2>Services</h2>
                </div>
                <hr>

                <!-- LIST -->
                <div class="list-holder" *ngIf="!showDetails">
                    <div class="tools">
                        <div class="search mg-right-auto">
                            <span class="svc-hint">
                                Turning a service off hides it in the consumer app and refuses new bookings for it.
                                Bookings already in progress are not cancelled.
                            </span>
                        </div>
                    </div>

                    <div class="svc-banner" *ngIf="disabledCount > 0">
                        <i class="fa fa-exclamation-circle"></i>
                        <span>
                            {{ disabledCount }}
                            {{ disabledCount === 1 ? 'service is' : 'services are' }} currently switched off and
                            cannot be booked.
                        </span>
                    </div>

                    <div class="list">
                        <table>
                            <thead>
                                <tr>
                                    <th>Service</th>
                                    <th>Status</th>
                                    <th>Unavailable Message</th>
                                    <th>Last Updated</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngIf="services.length !== 0; else noRecords">
                                    <tr *ngFor="let service of services">
                                        <td>{{ serviceLabel(service.serviceType) }}</td>
                                        <td>
                                            <span class="stat" [ngClass]="service.isEnabled ? 'svc-on' : 'svc-off'">
                                                {{ service.isEnabled ? 'Available' : 'Unavailable' }}
                                            </span>
                                        </td>
                                        <td>
                                            <span *ngIf="service.unavailableMessage">{{ service.unavailableMessage }}</span>
                                            <span *ngIf="!service.unavailableMessage" class="svc-muted">App default</span>
                                        </td>
                                        <td>{{ service.dateUpdated | date:'MM-dd-yyyy h:mm a' }}</td>
                                        <td><a (click)="viewDetails(service)" style="cursor: pointer;">View</a></td>
                                    </tr>
                                </ng-container>
                                <ng-template #noRecords>
                                    <tr>
                                        <td colspan="5" class="no-records-msg">
                                            <h6 class="ponds-contents-med-bold" *ngIf="isLoading">Loading…</h6>
                                            <h6 class="ponds-contents-med-bold" *ngIf="!isLoading && loadError === 'unsupported'">
                                                Not available on this environment yet.
                                            </h6>
                                            <h6 class="ponds-contents-med-bold" *ngIf="!isLoading && loadError === 'failed'">
                                                Connection not available. Please try again.
                                            </h6>
                                            <h6 class="ponds-contents-med-bold" *ngIf="!isLoading && loadError === 'none'">
                                                No records found
                                            </h6>
                                        </td>
                                    </tr>
                                </ng-template>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- DETAIL / EDIT -->
                <div class="list-holder" *ngIf="showDetails && detailViewed">
                    <div class="tools">
                        <div class="search mg-right-auto"></div>
                        <div class="profile-actions">
                            <button class="btn btn-sm btn-default" style="min-width: 100px;"
                                (click)="enableEditForm()" *ngIf="!enableEdit && canManage">Edit Details</button>
                            <button class="btn btn-sm btn-default" style="min-width: 100px;"
                                [disabled]="isSaving"
                                (click)="confirmUpdate(confirmUpdateModal)" *ngIf="enableEdit">Save</button>
                            <button class="btn btn-sm btn-outline" style="min-width: 100px;"
                                [disabled]="isSaving"
                                (click)="disableEditForm()" *ngIf="enableEdit">Cancel</button>
                            <button class="btn btn-sm btn-outline" style="min-width: 100px;"
                                (click)="returnToList()" *ngIf="!enableEdit">Back to List</button>
                        </div>
                    </div>

                    <div class="panel">
                        <div class="panel-info">
                            <div class="form-item">
                                <label class="form-label">Service</label>
                                <input type="text" class="form-control"
                                    [value]="serviceLabel(detailViewed.serviceType)" disabled="true">
                            </div>

                            <div class="form-item">
                                <label class="form-label">Status</label>
                                <select class="form-select" [disabled]="!enableEdit" [(ngModel)]="form.isEnabled">
                                    <option [ngValue]="true">Available &mdash; bookable as normal</option>
                                    <option [ngValue]="false">Unavailable &mdash; hidden and not bookable</option>
                                </select>
                            </div>

                            <div class="svc-warning" *ngIf="isTurningOff">
                                <i class="fa fa-exclamation-triangle"></i>
                                <span>
                                    This will stop new {{ serviceLabel(detailViewed.serviceType) }} bookings for
                                    everyone as soon as you save. Bookings already in progress continue normally.
                                </span>
                            </div>

                            <div class="form-item">
                                <label class="form-label">Unavailable Message</label>
                                <textarea class="form-control" rows="3" [maxlength]="maxMessageLength"
                                    placeholder="Leave blank to use the app's default wording"
                                    [(ngModel)]="form.unavailableMessage" [disabled]="!enableEdit"></textarea>
                                <small class="svc-hint">
                                    Shown in the popup when someone taps this service.
                                    {{ form.unavailableMessage.length }}/{{ maxMessageLength }} characters.
                                    Blank falls back to the app's own wording.
                                </small>
                            </div>

                            <div class="form-item">
                                <label class="form-label">Last Updated</label>
                                <input type="text" class="form-control"
                                    [value]="(detailViewed.dateUpdated | date:'MM-dd-yyyy h:mm a') || ''"
                                    disabled="true">
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<ng-template #confirmUpdateModal let-modal class="modal">
    <div class="modal-header">
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <p *ngIf="isTurningOff">
            Turn <strong>{{ serviceLabel(detailViewed!.serviceType) }}</strong> off? Nobody will be able to book it
            until you turn it back on.
        </p>
        <p *ngIf="!isTurningOff">
            Save changes to <strong>{{ serviceLabel(detailViewed!.serviceType) }}</strong>?
        </p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline" (click)="modal.dismiss('Cross click')">No, Cancel it</button>
        <button type="button" class="btn btn-default" [disabled]="isSaving"
            (click)="updateService(successUpdateModal)">Yes, Update</button>
    </div>
</ng-template>

<ng-template #successUpdateModal let-modal class="modal">
    <div class="modal-header">
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body success-body">
        <img src="../../../../assets/okito/images/modal-success.svg">
        <p>Service successfully updated</p>
        <button class="btn btn-default" (click)="closeAllModals()">Close</button>
    </div>
</ng-template>
